module.exports = __webpack_public_path__ + "static/quotegenerator-5622cb21a1ab560c2bb282d0f1f6ab02.jpg";